import bg_1 from "@/components/BlogFeed/bg_1.webp";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import SF_SocialShareCard_001 from "@/ui/SF_SocialShareCard_001";
import { Container, Stack } from "react-bootstrap";

import cn from "classnames";
import classes from "./styles.module.scss";

export default function ({ className = "pt-5 py-md-6", content, theme = "light" }) {
  return (
    <div className={cn(className, classes.BlogPostContent)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2:x1n:z0" image={bg_1} className={classes.bg_1} />
      <Container fluid="md" className="mw-xl border-bottom pb-4">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
      <Container fluid="md" className="mw-xl py-4">
        <Stack className="flex-column flex-md-row align-items-center gap-3">
          <span className="xsmall fw-bold opacity-60">Share this Article</span>
          <SF_SocialShareCard_001 />
        </Stack>
      </Container>
    </div>
  );
}
